import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import Assessment from './pages/Assessment';
import Payment from './pages/Payment';
import DetailedReport from './pages/DetailedReport';
import NextSteps from './pages/NextSteps';
import RequestQuote from './pages/RequestQuote';
import QuoteConfirmation from './pages/QuoteConfirmation';
import History from './pages/History';
import Admin from './pages/Admin';
import Welcome from './pages/Welcome';
import './App.css';

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const hasToken = !!localStorage.getItem('startin_token');
  if (!user && !hasToken) {
    return <Navigate to="/auth" replace />;
  }
  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  const hasToken = !!localStorage.getItem('startin_token');
  if (!user && !hasToken) {
    return <Navigate to="/auth" replace />;
  }
  if (user && !user.is_admin) {
    return <Navigate to="/assessment" replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route
        path="/welcome"
        element={
          <ProtectedRoute>
            <Welcome />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assessment"
        element={
          <ProtectedRoute>
            <Assessment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <History />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <Admin />
          </AdminRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/payment/:assessmentId" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
      <Route path="/reports/:assessmentId" element={<ProtectedRoute><DetailedReport /></ProtectedRoute>} />
      <Route path="/reports/:assessmentId/next-steps" element={<ProtectedRoute><NextSteps /></ProtectedRoute>} />
      <Route path="/reports/:assessmentId/quote/:packageId" element={<ProtectedRoute><RequestQuote /></ProtectedRoute>} />
      <Route path="/quote-requests/:requestId" element={<ProtectedRoute><QuoteConfirmation /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
